/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SecretCacheInvalidationResponse } from '../models/SecretCacheInvalidationResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminRuntimeService {

    /**
     * Clear Secret Cache
     * Invalidate cached secret reads across web and Celery processes.
     * @returns SecretCacheInvalidationResponse Successful Response
     * @throws ApiError
     */
    public static clearSecretCacheApiV1AdminRuntimeSecretCachePost(): CancelablePromise<SecretCacheInvalidationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/runtime/secret-cache',
        });
    }

}
